import * as ActionTypes from 'actions/partnerPlanRatingsUpload'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  ratingsUploaded: [],
}

// Updates error message to notify about the failed fetches.
export default function partnerPlanRatingsUpload(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLAN_RATINGS_DELETE_RECEIVED:
    case ActionTypes.PARTNERPLAN_RATINGS_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERPLAN_RATINGS_DELETE_COMPLETE:
    case ActionTypes.PARTNERPLAN_RATINGS_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        ratingsUploaded: action.ratingsUploaded,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlanRatingsUpload.js